import { connect } from 'react-redux';
import { State } from 'store/types';
import View from './View';
import { fetchSearchSuggestionWidgets } from 'store/searchSuggestions/action';

const mapDispatchToProps = {
  fetchSearchSuggestionWidgets,
};

const mapStateToProps = (state: State) => {
  const { searchSuggestions, remoteConfig } = state;
  const {
    isSearchWidgetLoading,
    isSearchWidgetError,
    searchSuggestionWidgets,
    remaining_inventories_ids,
    isPopularSuggestionLoaded,
  } = searchSuggestions;
  return {
    isSearchWidgetLoading: isSearchWidgetLoading,
    isSearchWidgetError: isSearchWidgetError,
    searchSuggestionWidgets: searchSuggestionWidgets,
    remainingInventoryIds: remaining_inventories_ids,
    isPaginationEnabled: !!remoteConfig.switches?.isPaginationEnabled || false,
    isPopularSuggestionLoaded: isPopularSuggestionLoaded,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
